import AppConfig from "../../../../config/AppConfig";
import IntegrationIcons from "../../common/icons/integrations/index";
import { INTEGRATION_KEYS } from "../IntegrationsHelper";

export default [
  {
    id: "desktop",
    name: "Desktop Sync",
    value: INTEGRATION_KEYS.desktop,
    autotrack_value: `autotrack_${INTEGRATION_KEYS.desktop}`,
    iconTag: IntegrationIcons.DesktopSyncIcon,
    description:
      "Get insights from activity in apps and on the web from your PC or Mac",
    isAvailable: true,
  },
  {
    id: "mobile_calendar",
    name: "Mobile Calendar (ex: iCal)",
    value: INTEGRATION_KEYS.calendar,
    autotrack_value: "autotrack_mobile_calendar",
    iconTag: IntegrationIcons.CalendarIcon,
    description: "Suggest or autotrack events whose names match Elements",
    isAvailable: true,
    isCalendar: 1,
    isDisabled: AppConfig.DISABLE_MOBILE_CAL,
  },
  {
    id: "google_calendar",
    name: "Google Calendar",
    value: INTEGRATION_KEYS.google,
    autotrack_value: "autotrack_google_calendar",
    iconTag: IntegrationIcons.GCalIcon,
    description: "Suggest or autotrack events whose names match Elements",
    isAvailable: true,
    isCalendar: 1,
  },
  {
    id: "outlook",
    name: "Outlook Calendar",
    value: INTEGRATION_KEYS.outlook,
    autotrack_value: "autotrack_outlook",
    icon: require("../../../../assets/integrations/outlook.png"),
    description: "Suggest or autotrack events whose names match Elements",
    isAvailable: true,
  },
  {
    id: "chrome",
    name: "Google Chrome",
    value: INTEGRATION_KEYS.chrome,
    autotrack_value: "autotrack_chrome",
    icon: require("../../../../assets/integrations/chrome.png"),
    description: "Get insights from browser activity ",
    isAvailable: true,
  },
  {
    id: "slack",
    name: "Slack",
    value: INTEGRATION_KEYS.slack,
    autotrack_value: "autotrack_slack",
    iconTag: IntegrationIcons.SlackIcon,
    description: "Suggest or autotrack Elements based on active threads",
    isAvailable: true,
  },
  {
    id: "apple_health",
    name: "Apple Health",
    value: INTEGRATION_KEYS.health,
    autotrack_value: "autotrack_health",
    icon: require("../../../../assets/integrations/health.png"),
    description: "Suggest or autotrack sleep, meditation, and workouts",
    isAvailable: true,
  },
  {
    id: "location",
    name: "Location",
    value: INTEGRATION_KEYS.location,
    autotrack_value: "autotrack_location",
    iconTag: IntegrationIcons.LocationIcon,
    description:
      "Suggest or autotrack Elements from your location patterns and trends",
    isAvailable: false,
  },
];
